import { render } from "./DataTableControl.vue?vue&type=template&id=510dfc43&scoped=true"
import script from "./DataTableControl.vue?vue&type=script&lang=js"
export * from "./DataTableControl.vue?vue&type=script&lang=js"

import "./DataTableControl.vue?vue&type=style&index=0&id=510dfc43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510dfc43"]])

export default __exports__